import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export enum SortDirection {
  NONE,
  ASC,
  DESC
}

export class Sort {
  constructor(public property: string,
              public direction: SortDirection = SortDirection.NONE) { }
}

@Component({
  selector: 'mpro-table-column',
  templateUrl: './table-column.component.html',
  styleUrls: ['./table-column.component.scss']
})
export class TableColumnComponent implements OnInit {
  public SortDirection = SortDirection;

  @Input() public header: string;
  @Input() public subheader: string;
  @Input() public property: string;
  @Input() public sortDir: SortDirection = SortDirection.NONE;
  @Input() public hideArrows: boolean;

  @Output() public sortChanged: EventEmitter<Sort> = new EventEmitter();

  public sort: Sort;

  public ngOnInit(): void {
    this.sort = new Sort(this.property, this.sortDir);
  }

  public doSort() {
    if (!this.sort.direction || this.sort.direction == SortDirection.DESC) {
      this.sort.direction = SortDirection.ASC;
    } else {
      this.sort.direction = SortDirection.DESC;
    }

    this.sortChanged.emit(this.sort);
  }


}
